import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
const Vistas = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
  useEffect(() => {
    const handleScroll = () => {
      const header = document.querySelector(".vistasHeader");
      if (window.scrollY > 50) {
        header?.classList.add("smallHeader");
      } else {
        header?.classList.remove("smallHeader");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  var settings = {
    dots: false,
    infinite: true,
    fade: true,
    speed: 500,
    slidesToShow: 1,
    autoplaySpeed: 2000,
    autoplay: true,
    slidesToScroll: 1,
  };
  return (
    <>
      <div className="vistasHeader">
        <div className="vistas-logo">
          <img
            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas-logo.png"
            className="img-fluid"
            alt="Lotus Valley School, Gurgaon"
          />
        </div>
        <div className="hamburger" onClick={toggleMenu}>
          {menuOpen ? "✖" : "☰"}
        </div>
        <ul className={`vistas-menu ${menuOpen ? "open" : ""}`}>
          <li>
            <Link to="/vistas">Introduction</Link>
          </li>
          <li>
            <Link to="/counselling-session-vistas">Counselling Session</Link>
          </li>
          {/* <li>
            <Link to="/counselling-session-vistas">Counselling Session</Link>
          </li> */}
          <li>
            <Link to="/upcomingevt-vistas">Upcoming Events</Link>
          </li>
          {/* <li>
            <Link to="/update-vistas">Updates</Link>
          </li> */}
          {/* <li>
            <Link to="/spotlight-vistas">Spotlight</Link>
          </li> */}
          <li>
            <Link to="/connect-vistas">Connect with Us</Link>
          </li>
        </ul>
      </div>
      <div className="slider-vistas">
        <Slider {...settings}>
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas1.jpg"
              alt="Lotus Valley Gurgaon"
              className="img-fluid"
            />{" "}
          </div>
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas2.jpg"
              alt="Lotus Valley Gurgaon"
              className="img-fluid"
            />{" "}
          </div>
          {/* <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas3.jpg"
              alt="Lotus Valley Gurgaon"
              className="img-fluid"
            />{" "}
          </div> */}
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas4.jpg"
              alt="Lotus Valley Gurgaon"
              className="img-fluid"
            />{" "}
          </div>
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas5.jpg"
              alt="Lotus Valley Gurgaon"
              className="img-fluid"
            />{" "}
          </div>
          {/* <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas6.jpg"
              alt="Lotus Valley Gurgaon"
              className="img-fluid"
            />{" "}
          </div> */}
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas7.jpg"
              alt="Lotus Valley Gurgaon"
              className="img-fluid"
            />{" "}
          </div>
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas8.jpg"
              alt="Lotus Valley Gurgaon"
              className="img-fluid"
            />{" "}
          </div>
        </Slider>
      </div>
      <div className="padding-wid vistas_p">
        <div class="container">
          <div class="text-center d-block">
            <h3 class="mx-auto text-black mb-4 font-play">
              Vistas: Success in Sight When You Plan Right
              <br />
              Career Counselling &amp; University Placement Cell
            </h3>
          </div>
          <div class="row justify-content-center mb-3">
            <div class="col-12 col-md-6">
              <div class="mb-3">
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas-intro1.jpeg"
                  class="img-fluid w-100"
                  alt="Lotus Valley Gurgaon"
                />
              </div>

              <div>
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas-intro2.jpeg"
                  class="img-fluid w-100"
                  alt="Lotus Valley Gurgaon"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 textarea">
              <section>
                <div class="heading text-left">
                  <h4 class="mx-auto font-play">
                    Welcome to ‘Vistas: Success in Sight when you Plan Right’,
                    the Lotus Career Counselling and University Placement Cell.
                    At Vistas, we empower our students to make informed and
                    confident career choices. Our mission is to ensure that
                    every student is equipped with the requisite knowledge and
                    resources needed for their academic &amp; professional
                    journey beyond school.
                  </h4>
                </div>
              </section>
            </div>
            <div class="col-md-12 textarea">
              <section>
                <div class="text-left mt-4">
                  <h4 class="mx-auto d-block  font-play">
                    What Sets Us Apart:
                  </h4>
                  <p>
                    We are proud to be a registered centre for some of the most
                    prestigious institutions in the world, thereby enabling our
                    students to explore a world of opportunities:
                  </p>
                  <p>
                    <b>
                      1. UCAS - The Universities and College Admission Services
                      in the UK. Buzz word(2024-25)-LOTUS25-
                    </b>{" "}
                    a gateway to world-class universities in the United
                    Kingdom.{" "}
                  </p>
                  <p>
                    <b>2. College Board, USA</b>
                    <br />
                    Our school is registered with a Level II code (CEEB
                    #671441), providing access to the vast resources and
                    standardized tests of the College Board.
                  </p>
                  <p>
                    <b>3. The Coalition for College, USA</b>
                    <br />
                    Offers a unique approach to the college application process,
                    creating opportunities for all students.
                  </p>
                  <p>
                    <b>
                      4. The Centre for Education in Mathematics and Computing,
                      University of Waterloo, Canada-{" "}
                    </b>
                    a prestigious institution that fosters excellence in
                    Mathematics and Computing.
                  </p>
                  <p>
                    <b>Our Objectives:</b>
                  </p>
                  <p>
                    At the Lotus Career Counselling and University Placement
                    Cell, we are dedicated to helping our students succeed by
                    providing comprehensive services such as:
                  </p>
                  <ul class="list">
                    <li>
                      Empowerment: We aim to empower learners by guiding them
                      through their career exploration journey, ensuring that
                      they have the tools and information needed to make
                      informed decisions about their future.
                    </li>
                    <li>
                      Streamlined Decision-Making: We provide step-by-step
                      resources to assist students in selecting the most
                      suitable streams and careers based on their interests,
                      strengths, and aspirations.
                    </li>
                    <li>
                      Effective Assessment: We design and implement
                      comprehensive assessment tools to evaluate the
                      effectiveness of our career-counselling sessions within a
                      school setting, continually improving our services to meet
                      the unique needs of each student.
                    </li>
                  </ul>

                  {/* <h4 class="mx-auto d-block font-play">Our Plan</h4>
                  <p>
                    <b>GRADE IX</b>
                    <br />
                    Mastering Foundations: Understand my Passion and Interests,
                    Drafting my Profile and Navigating Career Essentials
                  </p>
                  <p>
                    <b>GRADE X</b>
                    <br />
                    Global Educational Exploration: Considering Higher Education
                    Options at Home and Abroad
                  </p>
                  <p>
                    <b>GRADE XI</b>
                    <br />
                    Selecting my Ideal University/Program that Matches my
                    Abilities
                  </p>
                  <p>
                    <b>GRADE XII</b>
                    <br />
                    Odyssey of Aspirations: My Journey Through Dreams
                  </p> */}
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
      <div className="copyright-vistas">
        © 2024 All rights reserved with Lotus Valley School, Gurgaon
      </div>
    </>
  );
};
export default Vistas;
